import SingleBallotVoteFormContainer from './SingleBallotVoteFormContainer';

export default SingleBallotVoteFormContainer;
